/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MandateAssignmentEvaluation } from './mandateAssignmentEvaluation';
import type { MandateAssignmentEvents } from './mandateAssignmentEvents';

/**
 * API schema for mandate assignments.

Defines who is responsible for:
- evaluation: grading module submissions
- events: managing specific event kinds (by event_kind_id)
 */
export interface MandateAssignment {
  evaluation?: MandateAssignmentEvaluation;
  events?: MandateAssignmentEvents;
}
